export default __webpack_public_path__ + "static/features-target-5e1dfc056f4345d0940fec988d335194.jpg";